// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.3-next',
  revision: 'f231530be',
  branch: 'next',
  date: 'Tue, 16 Jun 2026 13:29:35 GMT'
};